import React from "react";
import icon1 from "../../icons/icon-coin.svg";


const featuresData = [
  {
    icon: icon1,
    title: "Your Loyalty Deserves More - Here’s What You Get",
    description: "2,000 free units released When you unlock your second wallet.",
  },
  {
    icon: icon1,
    title: "First 500,000 customers who reach Level 2",
    description:
      "Receive an additional 25,000 free units, released When you unlock your third wallet.",
  },
  {
    icon: icon1,
    title: "Next 1,500,000 customers who reach Level 2",
    description:
      "Receive 20,000 more free units, released When you unlock your third wallet.",
  },
  {
    icon: icon1,
    title: "First 1,000,000 customers who reach Level 3",
    description: "Receive 50,000 free units, released When you unlock your fourth wallet.",
  },
  {
    icon: icon1,
    title: "First 100,000 customers who reach Level 4",
    description: "Receive 500,000 free units, released When you unlock your fifth wallet.",
  },
  {
    icon: icon1,
    title: "First 100 customers who reach Level 5",
    description: "Receive a massive 1,000,000 free units, released When you unlock your sixth wallet.",
  },
];

const TokenomicsSection = () => {


  return (
    <section
      id="id_ico_tokenomics_section"
      className="ico_tokenomics_section section_space pb-5"
    >
      <div className="container">
        <div className="row justify-content-center">
               <div
          className="ico_heading_block text-center col-lg-8"
          data-aos="fade-up"
          data-aos-duration="600"
        >
            <h5 className="text-uppercase fw-normal">Start Your Journey with TopCoin UK </h5>
          <h2 className="heading_text mb-0"> Where Loyalty Becomes a Lifestyle</h2>
          <p>The first 2,000,000 customers who sign up will receive 2,000 free units instantly, released as cash when you unlock your Second Wallet. We’re rewarding our global community like never before. This exclusive launch package is only available to the first 2 million customers worldwide and the rewards only grow as you level up.</p>
        </div>

        </div>
     
        <div className="row align-items-center">
          {featuresData.map((feature, index) => (
            <div className="col-lg-6 position-relative z-1">
              <ul className="ico_features_group unordered_list_block">
                <li
                  key={index}
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div className="ico_iconbox_icon_left min-140">
                    <div className="iconbox_icon">
                      <img src={feature.icon} alt={feature.title} />
                    </div>
                    <div className="iconbox_info">
                      <h3 className="iconbox_title">{feature.title}</h3>
                      <p className="iconbox_description text-dark mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          ))}
        </div>
  <div className="text-center py-5">
    <p> Real Rewards. No Risk. Just Loyalty. No investments. No gambling. No pressure. Just loyalty, rewarded at every level. </p>
      <span className="fs-5 fw-bold">Real Rewards. No Risk. Just Loyalty.</span>
  </div>

   
      </div>
    </section>
  );
};

export default TokenomicsSection;
